module.exports = __webpack_public_path__ + "img/redlock-ssl-30days.219bbc3c.jpg";